module.exports = __webpack_public_path__ + "img/11.21461c00.png";